import styled from 'styled-components';

export const StyledPassField = styled.div`
  .secured input {
    font-family: 'text-security-disc', sans-serif !important;
    -webkit-text-security: disc !important;
  }
`;
